import { mixin } from '@/utils/mixins';
import { DIALOG_WIDTH } from '@/utils/constants';

export default {
  namespaced: true,
  mixins: [mixin],
  state: {
    intents: {},
    dialogData: {},
    bean: {},
    loading: false,
    singleDialogVisible: false,
    size: null
  },
  mutations: {
    setSize(state, size) {
      state.size = DIALOG_WIDTH[size] || DIALOG_WIDTH.M;
    },
    setIntents(state, intents) {
      state.intents = intents;
    },
    setLoading(state, val) {
      state.loading = val;
    },
    setMetadataDialog(state, metadata) {
      state.dialogData = metadata;
    },
    setBeanDialog(state, bean) {
      state.bean = bean;
    },
    setVisibleSingleDialog(state, visible) {
      state.singleDialogVisible = visible;
    },
    setRemoveDialogData(state) {
      state.singleDialogVisible = false;
      state.intents = {};
      state.dialogData = {};
      state.bean = {};
    }
  },
  actions: {
    async getPopupData({ commit, state }, { item, list = [] }) {
      commit('setMetadataDialog', {});
      commit('setVisibleSingleDialog', false);
      commit('setIntents', item);
      try {
        const { data } = await mixin.methods.sendFormRequestFromIntent(
          state.intents.intents[0],
          {
            selected_ids: list.map(item => item.ID)
          }
        );

        commit(
          'setMetadataDialog',
          data && data.metadata ? data.metadata : data.panels ? data : {}
        );
        commit('setBeanDialog', data.bean);

        if (data && data.metadata) {
          commit('setSize', item.intents[0].size);
          commit('setVisibleSingleDialog', true);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
